import type { SpecialPromotion } from '@/api/hooks'
import { formatMoney } from '@/lib/utils'

const wholeDollars = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

export function specialTerm(special: Pick<SpecialPromotion, 'extra_discount' | 'net_price' | 'perk'>): string {
  if (special.extra_discount) {
    return `Extra ${special.extra_discount.split('/').join('% + ')}%`
  }
  if (special.net_price != null) return `${formatMoney(special.net_price)} NET`
  return special.perk ?? '-'
}

export function specialMinimum(special: Pick<SpecialPromotion, 'min_order_net' | 'min_quantity'>): string | null {
  if (special.min_order_net != null) return `${wholeDollars.format(Number(special.min_order_net))} order`
  if (special.min_quantity != null) return `${special.min_quantity}+ units`
  return null
}

